import axios from 'axios'
import http from '@/services/http'

let cancelManufacturesSrc = null
let cancelTardinessSrc = null

export default {
  namespaced: true,
  state: {
    mininmized: false,
    manufacturesLoading: false,
    tardinessLoading: false
  },
  mutations: {
    SET_MINIMIZED(state, mininmized) {
      state.mininmized = mininmized
    },
    SET_MANUFACTURES_LOADING(state, manufacturesLoading) {
      state.manufacturesLoading = manufacturesLoading
    },
    SET_TARDINESS_LOADING(state, tardinessLoading) {
      state.tardinessLoading = tardinessLoading
    }
  },
  actions: {
    async getManufactures({ rootState, commit, rootGetters }) {
      const selectedCity = rootState.manufactures.selectedCity
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      cancelManufacturesSrc = source
      const sendedFilters = {}
      if (rootGetters['manufactures/areasIds']) {
        sendedFilters.area_ids = rootGetters['manufactures/areasIds']
      }
      try {
        commit('SET_MANUFACTURES_LOADING', true)
        const res = await http.get(`cities/${selectedCity.city_id}/dashboard/manufactures`, {
          cancelToken: source.token,
          params: {
            ...sendedFilters
          }
        })
        return res
      } finally {
        commit('SET_MANUFACTURES_LOADING', false)
      }
      
    },
    cancelManufactures() {
      if (cancelManufacturesSrc) {
        cancelManufacturesSrc.cancel()
      }
    },
    async getTardiness({ rootState, commit, rootGetters }) {
      const selectedCity = rootState.manufactures.selectedCity
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      cancelTardinessSrc = source
      const sendedFilters = {}
      if (rootGetters['manufactures/areasIds']) {
        sendedFilters.area_ids = rootGetters['manufactures/areasIds']
      }
      try {
        commit('SET_TARDINESS_LOADING', true)
        const res = await http.get(`cities/${selectedCity.city_id}/dashboard/tardiness`, {
          cancelToken: source.token,
          params: {
            ...sendedFilters
          }
        })
        return res
      } finally {
        commit('SET_TARDINESS_LOADING', false)
      }
    },
    cancelTardiness() {
      if (cancelTardinessSrc) {
        cancelTardinessSrc.cancel()
      }
    },
  }
}